import { useMemo } from 'react';
import { Modal } from 'react-bootstrap';

const toEmbedUrl = (type, url) => {
  if (!url) return '';
  if (type === 'YOUTUBE') {
    const match = url.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    const id = match ? match[1] : url;
    return `https://www.youtube.com/embed/${id}`;
  }
  if (type === 'VIMEO') {
    const match = url.match(/vimeo\.com\/(\d+)/);
    const id = match ? match[1] : url;
    return `https://player.vimeo.com/video/${id}`;
  }
  return url;
};

const VideoModal = ({ show, onHide, video }) => {
  const embedUrl = useMemo(() => toEmbedUrl(video?.videoType, video?.videoUrl), [video]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Body className="bg-black p-0">
        {video?.videoType === 'MP4' ? (
          <video controls className="h-full w-full">
            <source src={video.videoUrl} type="video/mp4" />
          </video>
        ) : (
          <iframe
            title={video?.title || 'Video'}
            src={embedUrl}
            className="h-[360px] w-full md:h-[480px]"
            allow="autoplay; fullscreen"
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VideoModal;
